import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_EXPENSE = `${BACKEND_BASEURL}api/expenses/`;
export const API_CASHSE = `${BACKEND_BASEURL}api/cashes/`;

const createExpenseOut = async (expenseData) => {
  const response = await axios.post(API_EXPENSE + "expenseOut", expenseData);
  return response.data;
};
const getExpenseOuts = async () => {
  const response = await axios.get(API_EXPENSE + "getExpenseOuts");
  return response.data;
};

const createCashIn = async (cashInData) => {
  const response = await axios.post(API_CASHSE + "cashIn", cashInData);
  return response.data;
};
const getCashIn = async () => {
  const response = await axios.get(API_CASHSE + "getCashIn");
  return response.data;
};
const updateCashEntry = async (cashInData) => {
  const response = await axios.patch(
    API_CASHSE + "updateCashEntry",
    cashInData
  );
  return response.data;
};
const deleteCash = async (id) => {
  const response = await axios.delete(`${API_CASHSE}deleteCash/${id}`);
  return response.message;
};
const updateExpenseEntry = async (expenseData) => {
  const response = await axios.patch(
    API_EXPENSE + "updateExpenseEntry",
    expenseData
  );
  return response.data;
};
const deleteExpense = async (id) => {
  const response = await axios.delete(`${API_EXPENSE}deleteExpense/${id}`);
  return response.message;
};
const getCashInForRrport = async (orderData) => {
  const response = await axios.post(
    API_CASHSE + "getCashInForRrport",
    orderData
  );
  return response.data;
};
const getExpenseOutForRrport = async (orderData) => {
  const response = await axios.post(
    API_EXPENSE + "getExpenseOutForRrport",
    orderData
  );
  return response.data;
};
const CashInOutServices = {
  getCashInForRrport,
  createExpenseOut,
  getExpenseOuts,
  createCashIn,
  getCashIn,
  deleteCash,
  deleteExpense,
  updateCashEntry,
  updateExpenseEntry,
  getExpenseOutForRrport,
};
export default CashInOutServices;
